import { CarRouteConfig } from "@/api/adHocCommands"
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"
import {
  carConfigs,
  matchPreset,
  VEHICLE_TYPE_NAMES,
  VehicleType,
} from "@/lib/vehiclePresets"

type Props = {
  currentConfig: CarRouteConfig | undefined
  onApply: (preset: CarRouteConfig) => void
  disabled?: boolean
}

const VehicleTypePresetSelector = ({
  currentConfig,
  onApply,
  disabled = false,
}: Props) => {
  const matched = matchPreset(currentConfig) ?? ""

  const handleChange = (value: string) => {
    if (!value) return
    const preset = carConfigs[value as VehicleType]
    if (preset) onApply(preset)
  }

  return (
    <ToggleGroup
      type="single"
      value={matched}
      onValueChange={handleChange}
      disabled={disabled}
      size="sm"
      className="flex flex-wrap items-center justify-start gap-1"
    >
      <ToggleGroupItem value="solo" aria-label={VEHICLE_TYPE_NAMES.solo}>
        {VEHICLE_TYPE_NAMES.solo}
      </ToggleGroupItem>
      <ToggleGroupItem value="solo72" aria-label={VEHICLE_TYPE_NAMES.solo72}>
        {VEHICLE_TYPE_NAMES.solo72}
      </ToggleGroupItem>
      <ToggleGroupItem value="bus" aria-label={VEHICLE_TYPE_NAMES.bus}>
        {VEHICLE_TYPE_NAMES.bus}
      </ToggleGroupItem>
      <ToggleGroupItem value="tir" aria-label={VEHICLE_TYPE_NAMES.tir}>
        {VEHICLE_TYPE_NAMES.tir}
      </ToggleGroupItem>
    </ToggleGroup>
  )
}

export default VehicleTypePresetSelector
